import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Hero.css";

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="hero">
      <div className="hero-background">
        <div className="hero-overlay"></div>
      </div>
      <div className="container">
        <div className="hero-content">
          <div
            className="hero-text"
            style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? "translateX(0)" : "translateX(-50px)",
              transition: "opacity 0.8s ease-out, transform 0.8s ease-out",
            }}
          >
            <h1 className="hero-title">
              Endüstriyel Kompresör Çözümlerinde
              <span className="highlight"> Güvenilir Ortağınız</span>
            </h1>
            <p className="hero-description">
              RPM Kompresör olarak, endüstriyel ihtiyaçlarınıza uygun yüksek
              kaliteli kompresör sistemleri sunuyoruz. 20 yıllık deneyimimizle
              sektörde öncüyüz.
            </p>
            <div className="hero-buttons">
              <Link to="/hizmetler" className="btn btn-primary">
                Hizmetlerimizi İnceleyin
              </Link>
              <Link to="/iletisim" className="btn btn-secondary">
                İletişime Geçin
              </Link>
            </div>
          </div>
          <div
            className="hero-image"
            style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? "translateX(0)" : "translateX(50px)",
              transition:
                "opacity 0.8s ease-out 0.3s, transform 0.8s ease-out 0.3s",
            }}
          >
            <div className="hero-image-placeholder">
              <div className="compressor-icon">⚙️</div>
              <p>Endüstriyel Kompresör</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
